import blogStyles from 'styles/Blog.module.css';
import styles from 'styles/StaffWanted.module.css';
import TitleLine from 'assets/images/rulebook/title_line.png';
import { Helmet } from "react-helmet-async";

const StaffWanted = () => {
  return (
    <>
      <div className={styles["first-view"]}>
        <Helmet>
          <title>スタッフ募集 | AREA CUP</title>
          <meta property="og:title" content="スタッフ募集 | AREA CUP" />
          <meta name="twitter:title" content="スタッフ募集 | AREA CUP" />
        </Helmet>
        <h1 className={styles["staff-wanted-title"]}>STAFF WANTED</h1>
        <div className={styles["staff-wanted"]}>
          <h2 className={styles["staff-wanted-text"]}>スタッフ募集</h2>
          <img src={TitleLine} className={styles["staff-wanted-image"]} draggable="false" />
          <div className={styles["diamond1"]}></div>
          <div className={styles["diamond2"]}></div>
        </div>
      </div>
      <div className={styles["background"]}>
        <div className={styles["container"]}>
          <div className={blogStyles["markdown"]}>
            <h1>AREA CUP スタッフ募集要項</h1>
            <p>&nbsp;</p>
            <p>
              AREA CUPは、有志のボランティアによって運営されている非公式大会です。AREA CUPでは、本大会の運営に携わって下さるスタッフを募集しています。
            </p>

            <p>&nbsp;</p>
 
            <h2>必須条件</h2>
            <p>すべての役職に共通する条件です。各役職の必須条件は各役職詳細をご覧ください。</p>
            <ul>
              <li><span style={{ color: "red" }}>Discord</span>と<span style={{ color: "red" }}>X(旧Twitter)</span>のアカウントを所持している方</li>
              <li><span style={{ color: "red" }}>任天堂の規約</span>や<span style={{ color: "red" }}>ガイドライン</span>を守って活動できる方</li>
              <li><span style={{ color: "red" }}>報連相</span>ができる方</li>
              <li><span style={{ color: "red" }}>やる気</span>がある方</li>
            </ul>

            <p>&nbsp;</p>

            <h2>求める人材</h2>
            <ul>
              <li><span style={{ color: "red" }}>円滑なコミュニケーション</span>が取れる方</li>
              <li><span style={{ color: "red" }}>スプラトゥーンが好き</span>な方</li>
              <li>スプラトゥーンコミュニティを<span style={{ color: "red" }}>盛り上げたい</span>方</li>
            </ul>

            <p>&nbsp;</p>

            <h2>募集役職</h2>
            <ul>
              <li>動画編集</li>
              <li>事務スタッフ</li>
              <li>エンジニア</li>
            </ul>

            <p>&nbsp;</p>
            <p>&nbsp;</p>

            <h1 style={{ color: "red" }}>動画編集者詳細</h1>

            <h2>必須条件</h2>
            <ul>
              <li>編集経験のある方</li>
              <li>Adobe Premiere Pro が使用できる方</li>
            </ul>

            <h2>歓迎項目</h2>
            <ul>
              <li>マーケティングスキル 知識 &lt; 実践レベル</li>
              <p>　※必須ではない</p>
            </ul>

            <h2>活動内容</h2>
            <ul>
              <li>AREA CUPのYouTubeやXに投稿している動画の作成</li>
              <li>新企画の担当</li>
              <li>どのような動画を作成するかは参考動画をご覧ください。</li>
            </ul>

            <h2>その他</h2>
            <ul>
              <li>稼働ノルマ等は一切なし！ご自身にあった形で活動していただいています。</li>
            </ul>

            <h2>参考動画</h2>
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/4EeNZVUlooM?si=p_KaepBtAvKjdcme"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            >
            </iframe>
            <h3>AREA CUP 切り抜き動画</h3>
            <p>毎月行っているAREA CUPの準決勝と決勝の切り抜き動画を作成しています。</p>
            <p>&nbsp;</p>
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/PhziGFe8USo?si=oNl32L0jLJoonr2g"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            >
            </iframe>
            <h3>AREA CUP Crown PV</h3>
            <p>今年の5月にAREA CUP Crownを行った際のPVです。</p>

            <p>&nbsp;</p>
            <p>&nbsp;</p>

            <h1 style={{ color: "red" }}>事務スタッフ詳細</h1>

            <h2>必須条件</h2>
            <ul>
              <li>なし</li>
            </ul>

            <h2>歓迎項目</h2>
            <ul>
              <li>スプレッドシートを使用したことがある方</li>
              <li>外国語ができる方（TOEIC650点程度）</li>
              <li>データや統計ができる方 / 得意な方</li>
            </ul>

            <h2>活動内容</h2>
            <ul>
              <li>スプレッドシートを使用した対戦表の管理</li>
              <li>Discord Botを使用した選手誘導</li>
              <li>配信サポート</li>
              <li>YouTubeモデレーター</li>
              <li>その他諸々</li>
              <p>（※すべてをやっていただくわけではありません。）</p>
            </ul>

            <h2>詳細</h2>
            <ul>
              <li><span style={{ color: "red" }}>稼働ノルマ等は一切なし！</span>ご自身にあった形で活動していただいています。</li>
              <li><span style={{ color: "red" }}>初心者大歓迎！</span>大会運営未経験者でもやる気さえあればOKです。先輩スタッフが優しく教えてくれます。</li>
            </ul>

            <p>&nbsp;</p>
            <p>&nbsp;</p>

            <h1 style={{ color: "red" }}>エンジニア詳細</h1>

            <h2>必須条件</h2>
            <ul>
              <li>Git / GitHub を用いたチーム開発の経験あり</li>
              <li>React / Next.js / Ruby on Rails のいずれかを用いた実務経験が半年以上</li>
            </ul>

            <h2>歓迎項目</h2>
            <ul>
              <li>Pythonを用いたDiscord Botの開発経験あり</li>
              <li>プログラミングが好きな方</li>
            </ul>

            <h2>活動内容</h2>
            <ul>
              <li>Webサイトの新機能追加</li>
              <li>DiscordのBot開発</li>
              <li>その他スタッフ用ツール開発</li>
            </ul>

            <h2>その他</h2>
            <ul>
              <li><span style={{ color: "red" }}>稼働ノルマ等は一切なし！</span>ご自身にあった形で活動していただいています。</li>
            </ul>

            <p>&nbsp;</p>
            <p>&nbsp;</p>

            <h1>応募方法</h1>
            <p>下記の応募フォームからご応募ください。</p>
            <p>後日AREA CUPスタッフより折り返しご連絡させていただきます。</p>

            <p>&nbsp;</p>

            <iframe 
              aria-label="Google Forms, AREA CUP スタッフ応募フォーム" 
              src="https://docs.google.com/forms/d/e/1FAIpQLSd39z7ozcntGoB5y-Qje9MioJBFZYPEnXTyHtp7U0aM9VEZRg/viewform?embedded=true" 
              width="100%"
              height="600">
            </iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default StaffWanted;
